import { useEffect, useRef } from 'react'

/** Track Alt and Shift key state via keydown/keyup so mid-drag key changes are detected. */
export function useModifierKeys() {
  const altHeldRef = useRef(false)
  const shiftHeldRef = useRef(false)

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      altHeldRef.current = e.altKey
      shiftHeldRef.current = e.shiftKey
    }

    window.addEventListener('keydown', onKey)
    window.addEventListener('keyup', onKey)
    return () => {
      window.removeEventListener('keydown', onKey)
      window.removeEventListener('keyup', onKey)
    }
  }, [])

  return { altHeldRef, shiftHeldRef }
}

export type ModifierKeys = ReturnType<typeof useModifierKeys>
